<template>
  <button type="submit" :class="`${assignSize} group relative flex justify-center border border-transparent text-sm leading-3 font-medium rounded-md focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out`">
    <span class="absolute left-0 inset-y-0 flex items-center pl-3">
      <slot name="icon" />
    </span>
    <slot />
  </button>
</template>

<script>
import { computed } from 'vue';
export default {
  props: {
    block: Boolean,
    size: String
  },
  setup(props) {
    const assignSize = computed(() => {
      switch (props.size) {
        case "small":
          return "lg:text-sm py-3 px-2"
        case "normal":
          return "lg:text-sm py-4 px-2"
        case "big":
          return "lg:text-lg py-5 px-4"
        default:
          break;
      }
    })

    return { assignSize }
  }
};
</script>

<style scoped>
button[block] {
  @apply w-full;
}
</style>
